import { Box, Link, Stack } from '@mui/material'
import { FC } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { gray } from 'src/features/muikds/kdsColors'

type Template = {
  id: number
  name: string
}

type Props = {
  templates: Template[]
}

/**
 * 紐付ひな形一覧
 *
 * 検索キーに紐づいているひな形をスクロール可能なリストで表示する
 */
export const LinkedTemplatesList: FC<Props> = ({ templates }) => {
  return (
    <Box
      sx={{
        backgroundColor: gray[0],
        borderRadius: 2,
        p: 2,
        maxHeight: 288,
        overflow: 'auto',
      }}
    >
      <Stack spacing={2}>
        {templates.map(template => (
          <Link
            key={template.id}
            component={RouterLink}
            to={`/templates/${template.id}/pages/edit`}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              wordBreak: 'break-word',
            }}
          >
            {template.name}
          </Link>
        ))}
      </Stack>
    </Box>
  )
}
